import * as cmMessageProperties from '../../consts/communicationLayer/cmMessageProperties';
import * as cmMessageTypes from '../../consts/communicationLayer/cmMessageTypes';
import * as firmwareErrorCodes from '../../consts/iot/firmwareErrorCodes';
import backendService from '../app/backendService';
import cmMessageRequestService from '../communicationLayer/cmMessageRequestService';
import connectivityService from '../device/connectivityService';
import yapWebSocketService from '../yap/yapWebSocketService';

const onFwuErrorHandler = ({
    errorCode = firmwareErrorCodes.GENERAL,
    errorFrame,
    eventType,
    fwu_target,
    lastRequestFrames,
    lastResponseFrames,
    onError,
}) => {
    if (onError) {
        onError({errorCode, errorFrame, fwu_target, eventType, lastRequestFrames, lastResponseFrames});
    }
};

const onPackageLoaded = (onSuccess, fwu_target) => {
    if (onSuccess) {
        onSuccess(fwu_target);
    }
};

const onFwuStatusEvent = ({onSuccess, status}) => {
    if (onSuccess) {
        onSuccess(status);
    }
};

const publishFwuFinishEvent = ({onSuccess, fwu_target}) => {
    if (onSuccess) {
        onSuccess(fwu_target);
    }
};

const publishFwuFinishAfterRebootEvent = () => {
    const isGamBackend = backendService.isGamBackend();
    const isBle = connectivityService.isBle();

    if (isGamBackend && isBle) {
        //reset gam wss because of keep alive issue
        yapWebSocketService.reconnectYapWebSockets();
    }

    cmMessageRequestService.publishFwuFinishAfterRebootEvent();
};

const publishCharacteristicStatusEvent = (statusPropertyName, frame) => {
    cmMessageRequestService.publishCharacteristicEvent({[statusPropertyName]: {frame}});
};

const publishResponseEvent = (data) => {
    const {frames, type, cyclicId, request_id, token, iterationNumber} = data || {};
    const isCmResponse =
        cyclicId &&
        frames &&
        (type === cmMessageTypes.STATUS_CHARACTERISTICS || type === cmMessageTypes.CYCLE_REQUESTS);

    if (!isCmResponse) return;

    const frame = frames[0];

    if (cyclicId === cmMessageProperties.CYCLE_FRAME) {
        cmMessageRequestService.publishCycleCharacteristicEvent({frame, request_id, token, iterationNumber});
    } else {
        publishCharacteristicStatusEvent(cyclicId, frame);
    }
};

// eslint-disable-next-line no-unused-vars
const publishCyclicErrorEvent = (data) => {
    //TODO: do something if cycle error
};

export default {
    onFwuErrorHandler,
    onPackageLoaded,
    onFwuStatusEvent,
    publishCyclicErrorEvent,
    publishFwuFinishEvent,
    publishFwuFinishAfterRebootEvent,
    publishResponseEvent,
    publishCharacteristicStatusEvent,
};
